// extracted by mini-css-extract-plugin
export default {"services-intro-container":"ServicesLanguages_services-intro-container__5JanP"};